import { useContext } from 'react';

import { SignFormContext } from '../context';

export function useSignFormInsideMobileModal(): boolean {
	const context = useContext(SignFormContext);
	return !!context?.insideMobileModal;
}
